// ======================================================================
// File: src/modules/ppe/pages/procurement/grn/list/GRNKpiBar.jsx
// Module: PPE → Procurement → GRN
//
// Purpose:
// - KPI summary bar for GRN list page
// - Frontend-only calculation similar to IndentKpiBar.jsx
// - Shows quick counts by status
// ======================================================================

import React from "react";

const GRN_STATUS = {
  DRAFT: "DRAFT",
  SUBMITTED: "SUBMITTED",
  APPROVED: "APPROVED",
  POSTED: "POSTED",
  CANCELLED: "CANCELLED",
};

export default function GRNKpiBar({ rows = [] }) {

  const total = rows.length;

  const count = (status) =>
    rows.filter((r) => r.status === status).length;

  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(5, 1fr)",
        gap: 16,
        marginBottom: 20,
      }}
    >
      <KpiCard
        label="Total"
        value={total}
        color="#0f766e"
      />

      <KpiCard
        label="Draft"
        value={count(GRN_STATUS.DRAFT)}
        color="#64748b"
      />

      <KpiCard
        label="Submitted"
        value={count(GRN_STATUS.SUBMITTED)}
        color="#0284c7"
      />

      <KpiCard
        label="Approved"
        value={count(GRN_STATUS.APPROVED)}
        color="#16a34a"
      />

      <KpiCard
        label="Posted"
        value={count(GRN_STATUS.POSTED)}
        color="#7c3aed"
      />
    </div>
  );
}

// -------------------------------------------------------------
// INTERNAL KPI CARD COMPONENT
// -------------------------------------------------------------

function KpiCard({ label, value, color }) {
  return (
    <div
      style={{
        background: "#fff",
        borderRadius: 12,
        padding: "14px 18px",
        borderLeft: `6px solid ${color}`,
        boxShadow: "0 1px 2px rgba(0,0,0,0.08)",
      }}
    >
      <div
        style={{
          fontSize: 13,
          color: "#6b7280",
          marginBottom: 4,
        }}
      >
        {label}
      </div>

      <div
        style={{
          fontSize: 22,
          fontWeight: 600,
          color: "#111827",
        }}
      >
        {value}
      </div>
    </div>
  );
}
